import { render, staticRenderFns } from "./TranslateWindow.vue?vue&type=template&id=529f6df1"
import script from "./TranslateWindow.vue?vue&type=script&lang=js"
export * from "./TranslateWindow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports